import script from "./EditableTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableTable.vue?vue&type=script&lang=ts&setup=true"

import "./EditableTable.vue?vue&type=style&index=0&id=0236a619&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0236a619"]])

export default __exports__